module.exports = __webpack_public_path__ + "img/lighting-studio_jp.d06a727.jpg";